import PropTypes from 'prop-types'
import React from 'react'

import { chainDecorators, memoized } from '../../utils/ReactUtils'

import styles from './styles'


const decorators = [
  memoized,
]

function HighlightedText(props) {
  const { text, className } = props
  const parts = text.split('|')

  const partNodes = parts.map((part, index) => {
    const spanProps = {
      key: `span-${index}`,
      children: part
        .split('\\n')
        .reduce((acc, val) => acc.concat(val, <br key={`br-${acc.length}`} />), []),

      className: (className ? `${className} ` : '') + (props.className === 'highlighted' ? 'highlighted' : 'normal'),
    }

    return <span {...spanProps} />
  })

  return (
    <>
      {partNodes}
      <style jsx>{styles}</style>
    </>
  )
}

HighlightedText.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string.isRequired,
}

HighlightedText.defaultProps = {
  className: null,
}

HighlightedText = chainDecorators(decorators, HighlightedText)

export default HighlightedText
